import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errText } from "@/lib/api";
import { Shield, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/crm"); }
    catch (e) { setErr(errText(e.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };
  const input = "w-full h-12 px-4 rounded-sm border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#C5A059]";

  return (
    <div className="min-h-screen bg-[#0B1E36] grain relative flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white rounded-sm p-8 relative z-10 animate-rise">
        <div className="flex items-center gap-2 mb-6">
          <Shield className="text-[#C5A059]" /><span className="font-display text-xl font-bold">Keystone Shield CRM</span>
        </div>
        <h1 className="font-display text-2xl font-bold flex items-center gap-2"><Lock size={20} /> Employee Login</h1>
        <p className="text-sm text-slate-500 mb-6">Secure access for Keystone Shield staff.</p>
        <form onSubmit={submit} className="space-y-4">
          <input className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          <input className={input} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          {err && <p className="text-sm text-red-600" data-testid="login-error">{err}</p>}
          <button disabled={loading} className="w-full bg-[#0B1E36] text-white font-bold h-12 rounded-sm hover:bg-[#C5A059] hover:text-[#0B1E36] transition-colors disabled:opacity-60" data-testid="login-submit">
            {loading ? "Signing in…" : "SIGN IN"}
          </button>
        </form>
      </div>
    </div>
  );
}
